<template>
  <div :id="id" />
</template>

<script>
import E from 'wangeditor'
import i18next from 'i18next'
import config from './config'
import { uploadFn } from 'api/common'

export default {
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'editor'
    },
    menus: {
      type: Array,
      default: () => config.menus
    },
    showFullScreen: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 200
    },
    actionUrl: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      editor: null,
      isChange: false
    }
  },
  watch: {
    value(val) {
      if (!this.isChange) this.editor.txt.html(val)
      this.isChange = false
    },
    disable: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            this.editor.disable()
          } else {
            this.editor.enable()
          }
        })
      }
    }
  },
  mounted() {
    this.init()
    this.editor.txt.html(this.value)
    this.$nextTick(() =>
      [...document.getElementsByClassName('w-e-toolbar')].forEach((el, index) => {
        el.style.zIndex = config.zIndex + 10 - index
      })
    )
  },
  methods: {
    setHtml(val) {
      this.editor.txt.html(val || this.value)
    },
    clearHtml() {
      this.editor && this.editor.txt.clear()
    },
    init() {
      this.editor = new E('#' + this.id)
      this.editor.config.height = this.height
      this.editor.config.menus = this.menus // 菜单1
      this.editor.config.zIndex = config.zIndex
      this.editor.config.lang = config.lang // 语言
      this.editor.config.showFullScreen = this.showFullScreen
      this.editor.config.languages[config.lang] = config.langTemplate // 语言包
      this.editor.i18next = i18next
      this.editor.config.onchangeTimeout = config.changeTimeout // 延迟
      this.editor.config.uploadImgMaxLength = 1 // 限制一次最多能传几张图片
      this.editor.config.customUploadImg = (files, fn) => {
        const loading = this.$loading({ body: true, text: this.$t('702') })
        const file_name = files[0].name.replace(/\s+/g, '')
        uploadFn(this.actionUrl, { file_name, type: 'WORK_ORDER' }).then(res => {
          if (res && res.code === 1) {
            const { put_url, content_type, object_url } = res.data
            const xhr = new XMLHttpRequest()
            xhr.open('PUT', put_url, true)
            xhr.setRequestHeader('Content-Type', content_type)
            xhr.send(files[0])
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 304) {
                  loading.close()
                  fn(object_url)
                }
              }
            }
          }
        })
      }
      this.editor.config.onchange = newHtml => {
        this.isChange = true
        this.$emit('update', newHtml)
      }
      this.editor.create()
    }
  }
}
</script>
